import { render } from "./hotelReport.vue?vue&type=template&id=9c2dd84c"
import script from "./hotelReport.vue?vue&type=script&lang=js"
export * from "./hotelReport.vue?vue&type=script&lang=js"

import "./hotelReport.vue?vue&type=style&index=0&id=9c2dd84c&lang=scss&scope=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__